import moment from 'moment-timezone';

import { OrderInfo } from 'common/types';

export const getDateForSort = (rentalInfo: OrderInfo): moment.Moment =>
	rentalInfo.channel !== 'STORE' && rentalInfo.startDate
		? moment(rentalInfo.startDate)
		: rentalInfo.created && rentalInfo.startDate
		? moment(rentalInfo.created).isSameOrAfter(moment().subtract(45, 'minutes')) &&
		  moment(rentalInfo.created).isSameOrAfter(moment(rentalInfo.startDate).subtract(45, 'minutes'))
			? moment(rentalInfo.created)
			: moment(rentalInfo.startDate)
		: moment();

export const sortRentalsByLatestDate = (a: OrderInfo, b: OrderInfo) => {
	const dateToFilterForA =
		a.channel !== 'STORE' && a.startDate
			? moment(a.startDate)
			: a.created
			? moment(a.created)
			: moment();
	const dateToFilterForB =
		b.channel !== 'STORE' && b.startDate
			? moment(b.startDate)
			: b.created
			? moment(b.created)
			: moment();
	return dateToFilterForA.isAfter(dateToFilterForB)
		? -1
		: dateToFilterForA.isBefore(dateToFilterForB)
		? 1
		: 0;
};

export const sortRentalsByEarliestDate = (a: OrderInfo, b: OrderInfo) => {
	const dateToFilterForA = getDateForSort(a);
	const dateToFilterForB = getDateForSort(b);
	return dateToFilterForA.isAfter(dateToFilterForB)
		? 1
		: dateToFilterForA.isBefore(dateToFilterForB)
		? -1
		: 0;
};
